import { Injectable }               from '@angular/core';
import { Observable }               from 'rxjs/Observable';
import { Response }                 from '@angular/http';

import { GuideDetail }              from './../../models/guide/guide-detail';
import { Guide }                    from './../../models/guide/guide';
import { ApiService }               from '../../root-services/api.service';

@Injectable()

export class GuideService {
  private guidesUrl = '/guides';

  _guides: Observable<Guide[]> = null;
  _guideDetail: Observable<GuideDetail> = null;
  _guideID: number;

  constructor(private api: ApiService) { }

  getGuides(): Observable<Guide[]> {
    if (!this._guides) {
      this._guides = this.api.get(this.guidesUrl)
                         .map((response: Response) => response.json() as Guide[])
                         .publishReplay(1).refCount()
                         .catch(this.handleError);
    }

    return this._guides;
  }

  getGuide(id: number): Observable<GuideDetail> {
    if (this._guideID !== id) {
      this._guideID = id;
      this._guideDetail = this.api.get(`${this.guidesUrl}/${id}`)
                                  .map((response: Response) => response.json() as GuideDetail)
                                  .publishReplay(1).refCount()
                                  .catch(this.handleError);
    }

    return this._guideDetail;
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error);
    return Promise.reject(error.message || error);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/guides/guide.service.ts